// @ts-nocheck
import {Column} from 'react-table'
import { useIntl } from 'react-intl';
import { CmsService } from '../../core/_models';
import { CmsServiceCustomHeader } from './CmsServiceCustomHeader';
import { CmsServiceActionsCell } from './CmsServiceActionsCell';

const cmsServicesColumns: ReadonlyArray<Column<CmsService>> = [
  {
    Header: (props) => (
      <CmsServiceCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'translations[0].title',
    Cell: ({ row }) => (
      <span>{row.original.translations?.[0]?.title}</span>
    ),
  },
  {
    Header: (props) => (
      <CmsServiceCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.DESCRIPTION' })}
        className='min-w-150px'
      />
    ),
    id: 'translations[0].description',
    Cell: ({ row }) => (
      <span className='text-truncate d-inline-block' style={{ maxWidth: '200px' }}>
        {row.original.translations?.[0]?.description || '-'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <CmsServiceCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.ORDER' })}
        className='min-w-75px'
      />
    ),
    id: 'order',
    Cell: ({ row }) => <span>{row.original.order ?? 0}</span>,
  },
  {
    Header: (props) => (
      <CmsServiceCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.STATUS' })}
        className='min-w-75px'
      />
    ),
    id: 'isActive',
    Cell: ({ row }) => {
      const intl = useIntl()
      return (
        <span>{row.original.isActive ? intl.formatMessage({ id: 'ECOMMERCE.COMMON.ACTIVE' }) : 'Inactive'}</span>
      )
    },
  },
  {
    Header: (props) => (
      <CmsServiceCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <CmsServiceActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {cmsServicesColumns}
